(() => {
  const slugify = (text) =>
    text
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, "")
      .trim()
      .replace(/\s+/g, "-");

  const initShareLinks = (root) => {
    const url = encodeURIComponent(window.location.href || "");
    root.querySelectorAll("[data-share-template]").forEach((link) => {
      const template = link.dataset.shareTemplate || "";
      link.setAttribute("href", template.replace("{current-link}", url));
    });
    const copyBtn = root.querySelector("[data-lfdl-copy-link]");
    if (copyBtn) {
      copyBtn.addEventListener("click", async () => {
        const link = window.location.href || "";
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(link);
          } else {
            const input = document.createElement("input");
            input.value = link;
            document.body.appendChild(input);
            input.select();
            document.execCommand("copy");
            document.body.removeChild(input);
          }
          alert("Lien copie dans le presse-papiers");
        } catch {
          alert("Copie impossible");
        }
      });
    }
  };

  const buildToc = (root) => {
    const content = root.querySelector("[data-lfdl-article-content]");
    const toc = root.querySelector("[data-lfdl-article-toc]");
    const list = root.querySelector("[data-lfdl-article-toc-list]");
    const toggle = root.querySelector("[data-lfdl-article-toc-toggle]");
    if (!content || !toc || !list) return;

    const showH3 = toc.dataset.lfdlTocShowH3 !== "false";
    const headings = content.querySelectorAll(showH3 ? "h2, h3" : "h2");
    if (!headings.length) {
      toc.hidden = true;
      return;
    }

    list.innerHTML = "";
    headings.forEach((heading, index) => {
      const text = heading.textContent.trim();
      if (!text) return;
      if (!heading.id) {
        heading.id = `${slugify(text)}-${index + 1}`;
      }
      const item = document.createElement("li");
      const link = document.createElement("a");
      const level = heading.tagName.toLowerCase();
      item.classList.add("lfdl-article-layout__toc-item", `lfdl-article-layout__toc-item--${level}`);
      link.classList.add("lfdl-article-layout__toc-link", `lfdl-article-layout__toc-link--${level}`);
      link.href = `#${heading.id}`;
      link.textContent = text;
      item.appendChild(link);
      list.appendChild(item);
    });

    if (toggle) {
      const labelShow = toggle.dataset.labelShow || "Voir";
      const labelHide = toggle.dataset.labelHide || "Cacher";
      toggle.addEventListener("click", () => {
        const isHidden = list.hasAttribute("hidden");
        if (isHidden) {
          list.removeAttribute("hidden");
          toggle.textContent = labelHide;
        } else {
          list.setAttribute("hidden", "hidden");
          toggle.textContent = labelShow;
        }
      });
    }
  };

  const init = () => {
    document.querySelectorAll("[data-lfdl-article]").forEach((root) => {
      buildToc(root);
      initShareLinks(root);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
